import image1 from 'assets/img/winners/1.jpg';
import image2 from 'assets/img/winners/2.jpg';
import image3 from 'assets/img/winners/3.jpg';
import image4 from 'assets/img/winners/4.png';
import image5 from 'assets/img/winners/5.jpg';
import image6 from 'assets/img/winners/6.jpg';
import image7 from 'assets/img/winners/7.jpg';
import image8 from 'assets/img/winners/8.jpg';

import petrol1 from 'assets/img/petrol/1.jpg';
import petrol2 from 'assets/img/petrol/2.jpg';
import petrol3 from 'assets/img/petrol/3.jpg';
import petrol4 from 'assets/img/petrol/4.jpg';

export const winnersList = [
  {
    'image': image2,
    'description': 'The way LMCT+ conducted themselves was of the utmost professional standards, from all the updated calls all the way to the famous delivery day. Thanks for making dreams come true... Love your work',
    'title': 'LUKE, MELBOURNE VIC',
    'subtitle': '$250K LC79 & BOAT WINNER'
  },
  {
    'image': image1,
    'description': 'I joined LMCT+ as a loyalty member for a couple of reasons. 1. Because they seemed to me like a great bunch doing some amazing things for kids. 2. Because out of all the draws I’ve ever been a part of none have had so many chances at quality cars like what you guys have. I never for the life of me thought I would actually win but bloody hell when they called I was speechless. If I could have picked one thing to win it would have absolutely been the RAM TRX and to get the call was mind blowing. I think I walked around work for a couple of days not actually knowing what to do with myself. I was grinning from ear to ear and colleagues were asking me why. We’ve had some really hard times in the last 10 years or so and winning this car feels like it has all turned around not just for me but for my family too. Thank you to all the team at LMCT+ each and everyone of you have been genuine, honest and all around amazing to deal with. ',
    'title': 'ANDREW, GOLD COAST QLD',
    'subtitle': 'RAM 1500 TRX WINNER'
  },
  {
    'image': image3,
    'description': 'I was having a $hit Sunday, nothing was going right. I threw my phone on my bed and walked away with no intention of answering it anymore.... an hour later my young fella brings me my phone as it was ringing. Initially I missed the call but when it rang again almost right away I answered it. When Adrian was on the other end of the line trying to tell me I`d won an R34 GTR I couldn`t believe it! Truly a life changing experience for me and my family. Not only did we have a great time whilst I had the car, but the money I received from the sale of the car helped me buy a house. Knowing that I now have that stability for me and my family means everything to me.',
    'title': 'Steve S, QLD',
    'subtitle': 'R34 GTR WINNER'
  },
  {
    'image': image4,
    'description': 'The whole journey from receiving the phone call from Adrian to seeing the prize in my driveway has been nothing short of life changing for myself. I was in disbelief at first as I couldn`t process it but once I saw the Facebook live as well, I knew it was true and unreal. The after process as well was very quick and organised, Sammy gave me a call the next day to get everything organised and kept me in the loop as to when everything was happening. This has been a dream come true for me and I 100% have recommended my friends & family to sign up as well to be in the running for LMCT`s life changing prizes!',
    'title': 'ANIK, MELBOURNE VIC',
    'subtitle': 'LC300 + PATRIOT CAMPER WINNER'
  },
  {
    'image': image5,
    'description': 'The call that changed my life, Adrian on one end telling me I had won the HSV GTSR and me struggling to believe him on the other while letting out a few choice words. I was one to believe it would never happen to me but it sure did and I was lucky enough to now own a car I would never have had the privilege to otherwise. While I had some fun and enjoyed it, it is now being loved by the next custodian while we now are lucky enough to have bought our house which my whole family can enjoy, with a Holden still in the shed! LMCT has changed all our lives for the better and we are ever so grateful! Thank you',
    'title': 'ADRIAN, SOUTH AUSTRALIA',
    'subtitle': 'HSV GTSR WINNER'
  },
  {
    'image': image6,
    'description': 'Thank you LMCT+. Words cannot explain our gratitude and how thankful we are. Thanks to you and being very lucky we have no financial burdens and are set for our future. It was an unreal experience getting that lucky phone call, something we will remember forever. We will continue to be members as long as LMCT is around. Keep up the good legends. Be sure to let me know if your ever in Tassie, beers on me. Thanks again!',
    'title': 'Shaun, Tasmania',
    'subtitle': 'Gold Coast House Winner'
  },
  {
    'image': image7,
    'description': 'LMCT+ were a very professional organisation to deal with and everything they said they would do they delivered. What a life changing experience as soon as I answered that phone, the car was immaculate can’t thank the boys enough!!',
    'title': 'TOMMY MELBOURNE VIC',
    'subtitle': 'XY GT REPLICA WINNER'
  },
  {
    'image': image8,
    'description': 'What to say, that was an unexpected phone call that’s for sure . I initially thought it was a telemarketer but the boys could sniff that out, and then when they said they’re from LMCT+. I was a bit stunned.I was only thinking a few weeks earlier a Ute would be great for camping, next thing you no lmct are on the phone, then a few weeks later I have this Brand New ranger in my drive away and I still cannot wipe the smile off my face! I can’t be happier and a  big thanks for the life-changing prize, and thanks to all the team at lmct, great times ahead ',
    'title': 'RYAN, CAIRNS QLD',
    'subtitle': 'NEXT GEN FORD RANGER WINNER'
  }
];

export const galleryList = [
  petrol1, petrol2, petrol3, petrol4, petrol1, petrol2, petrol3, petrol4
];

export const reviewsList = [
  {
    'description': 'Over the past few years I\'ve purchased a few silver packages whenever there is an upcoming event or something I need to purchase through their partners, an absolute no brainer for me',
    'title': 'Jack H',
    'subtitle': 'Silver Package'
  },
  {
    'description': 'Long time loyalty member here and can say I have loved being apart of the LMCT+ Community. Loved being able to meet the guys at the W1 event they put on and can\'t wait for more! Absolute legends!',
    'title': 'Harry P',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'Wanted to know what the hype was about so I purchased a Bronze Package to give it a shot. On top of being apart of the promotion, I was also able to access special offers from members portal. I ended up saving 10% off with Ultratune and will definitely be purchasing again.',
    'title': 'Tom H',
    'subtitle': 'First Time Purchase'
  },
  {
    'description': 'Excellent customer service! I was having issues logging in and they were onto it straight away. Finally logged in and was able to view the features on the site. I have taken full advantage of the Mates Rates part and was able to receive $100 off my first purchase at Naked Wines. Will definitely be making more use of their special offers.',
    'title': 'Sharon H',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'Purchased a coupe of times before but never really saw the point of being able to have access to the database until I logged in and had a proper look. Ended up saving myself 15% at Beaurepairs and will definitely be making use of the special offers they have next time I make a purchase.',
    'title': 'Josh B',
    'subtitle': 'Silver Package'
  },
  {
    'description': 'Was able to get some sick discounts through the members portal after making a one off purchase. Might have to join soon to keep getting all the perks.',
    'title': 'Liam H',
    'subtitle': 'Silver Package'
  },
  {
    'description': 'Nice meeting the boys and getting to know them at their meet and greets, absolute legends!',
    'title': 'Ben A',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'Had the pleasure of meeting the team at one of their track days and can’t wait to be able to meet them again!',
    'title': 'James S',
    'subtitle': 'Platinum Package'
  },
  {
    'description': 'Thanks to the mates rates section of the members area, I’ve been able to save hundreds on my car servicing over the last 2 years.',
    'title': 'Naomi G',
    'subtitle': 'Long Time Loyalty Member'
  },
  {
    'description': 'Had the pleasure of meeting the team at one of the events they hosted and can\'t wait to participate when they do more!',
    'title': 'John S',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'Met the team at one of their meet and greets and have to say they are the most genuine blokes!',
    'title': 'Will N',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'Taken advantage of the offers in their mates rates part of the portal and would highly recommend having a look at the specials if you haven\'t already!',
    'title': 'Bryan F',
    'subtitle': 'Silver Package'
  },
  {
    'description': 'Joined up after my partner did - He\'s addended LMCT+ hosted events and we have both been able to save from the specials they offer in the portal. We have both benefited greatly from being a member and I would definitely recommend giving it a go if you haven\'t already.',
    'title': 'Stephanie L',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'I\'ve been a loyalty member for 4 months and have saved more through their partner Interior Secrets than what the membership has cost me!',
    'title': 'Stacey T',
    'subtitle': 'Loyalty Member'
  },
  {
    'description': 'First time purchasing and was able to get 15% off at Smooth as Detailing! Will definitely be purchasing again.',
    'title': 'Sarah N',
    'subtitle': 'Silver Package'
  },
  {
    'description': 'Wnated to try out LMCT+ and ended up saving $100 on art from Urban Rd and have now become a loyalty member as the benefits are crazy!',
    'title': 'Lisa F',
    'subtitle': 'Bronze Package'
  },
  {
    'description': 'Being able to get discounts from some of the best performance shops across Australia has been great! Went down to Morpowa in SA and saved $800 off a tune and exhuast package.',
    'title': 'Arron L',
    'subtitle': ''
  },
  {
    'description': 'Made a purchase and realised I was given limited access to the database. Decided I would have a look and ended up saving 10% off on 4WD upgrades at Pro 4x4 SA.',
    'title': 'Alex K',
    'subtitle': 'One Off Purchase'
  },
  {
    'description': 'The guys on the phone offered great support in navigating the members site. I was able to make my purchase using discounts through the portal. They have some great specials!',
    'title': 'Cooper P',
    'subtitle': 'Loyalty Member'
  },
];